export enum MessageEventType {
  ORDER_PAID_COM_CLIENT_FI = 0,
  ORDER_PAID_COM_CLIENT_EN = 1,
  ORDER_CONFIRMATION_COM_CLIENT_FI = 2,
  ORDER_CONFIRMATION_COM_CLIENT_EN = 3,
  ORDER_CONFIRMATION_COM_CLIENT_FI_PHASE_1 = 4,
  ORDER_CONFIRMATION_COM_CLIENT_EN_PHASE_1 = 5,
  ORDER_CONFIRMATION_COM_CLIENT_FI_PHASE_2 = 6,
  ORDER_CONFIRMATION_COM_CLIENT_FI_PHASE_3 = 7,
  ORDER_CONFIRMATION_COM_CLIENT_EN_PHASE_2 = 8,
  ORDER_CONFIRMATION_COM_CLIENT_EN_PHASE_3 = 9,
  ORDER_CANCELLATION_COM_CLIENT_FI = 10,
  ORDER_CANCELLATION_COM_CLIENT_EN = 11,
  WELCOME_MESSAGE_COM_CLIENT_EMAIL_FI = 12,
  WELCOME_MESSAGE_COM_CLIENT_EMAIL_EN = 13,
  WELCOME_MESSAGE_COM_CLIENT_SMS_FI = 14,
  WELCOME_MESSAGE_COM_CLIENT_SMS_EN = 15,
  ORDER_CONFIRMATION_COM_OWNER_FI = 16,
  ORDER_CONFIRMATION_COM_OWNER_EN = 17,
  ORDER_CANCELLATION_COM_OWNER_FI = 18,
  ORDER_CANCELLATION_COM_OWNER_EN = 19,
  ORDER_CONFIRMATION_COM_CARETAKER_FI = 20,
  ORDER_CONFIRMATION_COM_CARETAKER_EN = 21,
  ORDER_CANCELLATION_COM_CARETAKER_FI = 22,
  ORDER_CANCELLATION_COM_CARETAKER_EN = 23,
  ORDER_CONFIRMATION_COM_SMS_OWNER_FI = 24,
  ORDER_CONFIRMATION_COM_SMS_OWNER_EN = 25,
  ORDER_CONFIRMATION_COM_SMS_CARETAKER_FI = 26,
  ORDER_CONFIRMATION_COM_SMS_CARETAKER_EN = 27,
  ORDER_CONFIRMATION_COM_SMS_CLIENT_FI = 28,
  ORDER_CONFIRMATION_COM_SMS_CLIENT_EN = 29,
  ORDER_CONFIRMATION_COM_CLIENT_FI_PHASE_1_SUOMU = 30,
  ORDER_CONFIRMATION_COM_CLIENT_EN_PHASE_1_SUOMU = 31,
  ORDER_CANCELLATION_COM_CLIENT_FI_SUOMU = 32,
  ORDER_CANCELLATION_COM_CLIENT_EN_SUOMU = 33,
  ORDER_CONFIRMATION_COM_OWNER_FI_SUOMU = 34,
  ORDER_CONFIRMATION_COM_OWNER_EN_SUOMU = 35,
  ORDER_CANCELLATION_COM_OWNER_FI_SUOMU = 36,
  ORDER_CANCELLATION_COM_OWNER_EN_SUOMU = 37,
  ORDER_CONFIRMATION_COM_CARETAKER_FI_SUOMU = 38,
  ORDER_CONFIRMATION_COM_CARETAKER_EN_SUOMU = 39,
  ORDER_CANCELLATION_COM_CARETAKER_FI_SUOMU = 40,
  ORDER_CANCELLATION_COM_CARETAKER_EN_SUOMU = 41,
  ORDER_BILLS_SEND,
  ORDER_CREATION_TRAVELAGENCY_SEND = 43,
}

export const messageEventTypeTranslations = {
  en: {
    [MessageEventType.ORDER_PAID_COM_CLIENT_FI]:
      'Booking Paid CLIENT message FI',
    [MessageEventType.ORDER_PAID_COM_CLIENT_EN]:
      'Booking Paid CLIENT message EN',
    [MessageEventType.ORDER_CONFIRMATION_COM_CLIENT_FI]:
      'Booking Confirmation CLIENT message FI',
    [MessageEventType.ORDER_CONFIRMATION_COM_CLIENT_EN]:
      'Booking Confirmation CLIENT message EN',
    [MessageEventType.ORDER_CONFIRMATION_COM_CLIENT_FI_PHASE_1]:
      'Booking Confirmation CLIENT message FI – Phase 1',
    [MessageEventType.ORDER_CONFIRMATION_COM_CLIENT_EN_PHASE_1]:
      'Booking Confirmation CLIENT message EN – Phase 1',
    [MessageEventType.ORDER_CONFIRMATION_COM_CLIENT_FI_PHASE_2]:
      'Booking Confirmation CLIENT message FI – Phase 2',
    [MessageEventType.ORDER_CONFIRMATION_COM_CLIENT_FI_PHASE_3]:
      'Booking Confirmation CLIENT message FI – Phase 3',
    [MessageEventType.ORDER_CONFIRMATION_COM_CLIENT_EN_PHASE_2]:
      'Booking Confirmation CLIENT message EN – Phase 2',
    [MessageEventType.ORDER_CONFIRMATION_COM_CLIENT_EN_PHASE_3]:
      'Booking Confirmation CLIENT message EN – Phase 3',
    [MessageEventType.ORDER_CANCELLATION_COM_CLIENT_FI]:
      'Booking Cancellation CLIENT message FI',
    [MessageEventType.ORDER_CANCELLATION_COM_CLIENT_EN]:
      'Booking Cancellation CLIENT message EN',
    [MessageEventType.ORDER_CANCELLATION_COM_CLIENT_FI_SUOMU]:
      'Booking Cancellation CLIENT message FI',
    [MessageEventType.ORDER_CANCELLATION_COM_CLIENT_EN_SUOMU]:
      'Booking Cancellation CLIENT message EN',
    [MessageEventType.WELCOME_MESSAGE_COM_CLIENT_EMAIL_FI]:
      'Booking Welcome message CLIENT FI email',
    [MessageEventType.WELCOME_MESSAGE_COM_CLIENT_EMAIL_EN]:
      'Booking Welcome message CLIENT EN email',
    [MessageEventType.WELCOME_MESSAGE_COM_CLIENT_SMS_FI]:
      'Booking Welcome message CLIENT FI sms',
    [MessageEventType.WELCOME_MESSAGE_COM_CLIENT_SMS_EN]:
      'Booking Welcome message CLIENT EN sms',
    [MessageEventType.ORDER_CONFIRMATION_COM_OWNER_FI]:
      'Booking Confirmation message OWNER FI',
    [MessageEventType.ORDER_CONFIRMATION_COM_OWNER_EN]:
      'Booking Confirmation message OWNER EN',
    [MessageEventType.ORDER_CONFIRMATION_COM_OWNER_FI_SUOMU]:
      'Booking Confirmation message OWNER FI',
    [MessageEventType.ORDER_CONFIRMATION_COM_OWNER_EN_SUOMU]:
      'Booking Confirmation message OWNER EN',
    [MessageEventType.ORDER_CANCELLATION_COM_OWNER_FI]:
      'Booking Cancellation message OWNER FI',
    [MessageEventType.ORDER_CANCELLATION_COM_OWNER_EN]:
      'Booking Cancellation message OWNER EN',
    [MessageEventType.ORDER_CANCELLATION_COM_OWNER_FI_SUOMU]:
      'Booking Cancellation message OWNER FI',
    [MessageEventType.ORDER_CANCELLATION_COM_OWNER_EN_SUOMU]:
      'Booking Cancellation message OWNER EN',
    [MessageEventType.ORDER_CONFIRMATION_COM_CARETAKER_FI]:
      'Booking Confirmation message CARETAKER FI',
    [MessageEventType.ORDER_CONFIRMATION_COM_CARETAKER_EN]:
      'Booking Confirmation message CARETAKER EN',
    [MessageEventType.ORDER_CANCELLATION_COM_CARETAKER_FI]:
      'Booking Cancellation message CARETAKER FI',
    [MessageEventType.ORDER_CANCELLATION_COM_CARETAKER_EN]:
      'Booking Cancellation message CARETAKER EN',
    [MessageEventType.ORDER_CANCELLATION_COM_CARETAKER_FI_SUOMU]:
      'Booking Cancellation message CARETAKER FI',
    [MessageEventType.ORDER_CANCELLATION_COM_CARETAKER_EN_SUOMU]:
      'Booking Cancellation message CARETAKER EN',
    [MessageEventType.ORDER_CONFIRMATION_COM_SMS_OWNER_FI]:
      'Booking Confirmation message OWNER FI sms',
    [MessageEventType.ORDER_CONFIRMATION_COM_SMS_OWNER_EN]:
      'Booking Confirmation message OWNER EN sms',
    [MessageEventType.ORDER_CONFIRMATION_COM_SMS_CARETAKER_FI]:
      'Booking Confirmation message CARETAKER FI sms',
    [MessageEventType.ORDER_CONFIRMATION_COM_SMS_CARETAKER_EN]:
      'Booking Confirmation message CARETAKER EN sms',
    [MessageEventType.ORDER_CONFIRMATION_COM_SMS_CLIENT_FI]:
      'Booking Confirmation message CLIENT FI sms',
    [MessageEventType.ORDER_CONFIRMATION_COM_SMS_CLIENT_EN]:
      'Booking Confirmation message CLIENT EN sms',
    [MessageEventType.ORDER_CONFIRMATION_COM_CLIENT_FI_PHASE_1_SUOMU]:
      'Booking Confirmation CLIENT message FI – Phase 1',
    [MessageEventType.ORDER_CONFIRMATION_COM_CLIENT_EN_PHASE_1_SUOMU]:
      'Booking Confirmation CLIENT message EN – Phase 1',
    [MessageEventType.ORDER_CONFIRMATION_COM_CARETAKER_FI_SUOMU]:
      'Booking Confirmation message CARETAKER FI',
    [MessageEventType.ORDER_CONFIRMATION_COM_CARETAKER_EN_SUOMU]:
      'Booking Confirmation message CARETAKER EN',
    [MessageEventType.ORDER_BILLS_SEND]: 'Booking Invoices sent',
    [MessageEventType.ORDER_CREATION_TRAVELAGENCY_SEND]:
      'Travel agency user made booking - confirmation',
  },
  fi: {
    [MessageEventType.ORDER_PAID_COM_CLIENT_FI]:
      'Varaus maksettu viesti ASIAKAS FI',
    [MessageEventType.ORDER_PAID_COM_CLIENT_EN]:
      'Varaus maksettu viesti ASIAKAS EN',
    [MessageEventType.ORDER_CONFIRMATION_COM_CLIENT_FI]:
      'Varaus vahvistettu viesti ASIAKAS FI',
    [MessageEventType.ORDER_CONFIRMATION_COM_CLIENT_EN]:
      'Varaus vahvistettu viesti ASIAKAS EN',
    [MessageEventType.ORDER_CONFIRMATION_COM_CLIENT_FI_PHASE_1_SUOMU]:
      'Varaus vahvistettu viesti ASIAKAS FI',
    [MessageEventType.ORDER_CONFIRMATION_COM_CLIENT_EN_PHASE_1_SUOMU]:
      'Varaus vahvistettu viesti ASIAKAS EN',
    [MessageEventType.ORDER_CONFIRMATION_COM_CLIENT_EN_PHASE_1]:
      'Varaus vahvistettu viesti ASIAKAS EN – Vaihe 1',
    [MessageEventType.ORDER_CONFIRMATION_COM_CLIENT_FI_PHASE_2]:
      'Varaus vahvistettu viesti ASIAKAS FI – Vaihe 2',
    [MessageEventType.ORDER_CONFIRMATION_COM_CLIENT_FI_PHASE_3]:
      'Varaus vahvistettu viesti ASIAKAS FI – Vaihe 3',
    [MessageEventType.ORDER_CONFIRMATION_COM_CLIENT_EN_PHASE_2]:
      'Varaus vahvistettu viesti ASIAKAS EN – Vaihe 2',
    [MessageEventType.ORDER_CONFIRMATION_COM_CLIENT_EN_PHASE_3]:
      'Varaus vahvistettu viesti ASIAKAS EN – Vaihe 3',
    [MessageEventType.ORDER_CANCELLATION_COM_CLIENT_FI]:
      'Varaus peruttu viesti ASIAKAS FI',
    [MessageEventType.ORDER_CANCELLATION_COM_CLIENT_EN]:
      'Varaus peruttu viesti ASIAKAS EN',
    [MessageEventType.WELCOME_MESSAGE_COM_CLIENT_EMAIL_FI]:
      'Varaus tervetuloa viesti ASIAKAS FI',
    [MessageEventType.WELCOME_MESSAGE_COM_CLIENT_EMAIL_EN]:
      'Varaus tervetuloa viesti ASIAKAS EN',
    [MessageEventType.WELCOME_MESSAGE_COM_CLIENT_SMS_FI]:
      'Varaus tervetuloa viesti ASIAKAS FI sms',
    [MessageEventType.WELCOME_MESSAGE_COM_CLIENT_SMS_EN]:
      'Varaus tervetuloa viesti ASIAKAS EN sms',
    [MessageEventType.ORDER_CONFIRMATION_COM_OWNER_FI]:
      'Varaus vahvistettu viesti OMISTAJA FI',
    [MessageEventType.ORDER_CONFIRMATION_COM_OWNER_EN]:
      'Varaus vahvistettu viesti OMISTAJA EN',
    [MessageEventType.ORDER_CONFIRMATION_COM_OWNER_FI_SUOMU]:
      'Varaus vahvistettu viesti OMISTAJA FI',
    [MessageEventType.ORDER_CONFIRMATION_COM_OWNER_EN_SUOMU]:
      'Varaus vahvistettu viesti OMISTAJA EN',
    [MessageEventType.ORDER_CONFIRMATION_COM_CARETAKER_FI_SUOMU]:
      'Varaus vahvistettu viesti HUOLTAJA FI',
    [MessageEventType.ORDER_CONFIRMATION_COM_CARETAKER_EN_SUOMU]:
      'Varaus vahvistettu viesti HUOLTAJA EN',
    [MessageEventType.ORDER_CONFIRMATION_COM_SMS_CLIENT_FI]:
      'Varaus vahvistettu viesti ASIAKAS FI sms',
    [MessageEventType.ORDER_CONFIRMATION_COM_SMS_CLIENT_EN]:
      'Varaus vahvistettu viesti ASIAKAS EN sms',
    [MessageEventType.ORDER_CONFIRMATION_COM_CLIENT_FI_PHASE_1]:
      'Varaus vahvistettu viesti ASIAKAS FI – Vaihe 1',
    [MessageEventType.ORDER_CONFIRMATION_COM_CARETAKER_FI]:
      'Varaus vahvistettu viesti HUOLTAJA FI',
    [MessageEventType.ORDER_CONFIRMATION_COM_CARETAKER_EN]:
      'Varaus vahvistettu viesti HUOLTAJA EN',
    [MessageEventType.ORDER_CANCELLATION_COM_OWNER_FI]:
      'Varaus peruttu viesti OMISTAJA FI',
    [MessageEventType.ORDER_CANCELLATION_COM_OWNER_EN]:
      'Varaus peruttu viesti OMISTAJA EN',
    [MessageEventType.ORDER_CANCELLATION_COM_OWNER_FI_SUOMU]:
      'Varaus peruttu viesti OMISTAJA FI',
    [MessageEventType.ORDER_CANCELLATION_COM_OWNER_EN_SUOMU]:
      'Varaus peruttu viesti OMISTAJA EN',
    [MessageEventType.ORDER_CANCELLATION_COM_CARETAKER_FI]:
      'Varaus peruttu viesti HUOLTAJA FI',
    [MessageEventType.ORDER_CANCELLATION_COM_CARETAKER_EN]:
      'Varaus peruttu viesti HUOLTAJA EN',
    [MessageEventType.ORDER_CANCELLATION_COM_CARETAKER_FI_SUOMU]:
      'Varaus peruttu viesti HUOLTAJA FI',
    [MessageEventType.ORDER_CANCELLATION_COM_CARETAKER_EN_SUOMU]:
      'Varaus peruttu viesti HUOLTAJA EN',
    [MessageEventType.ORDER_CONFIRMATION_COM_SMS_OWNER_FI]:
      'Varaus vahvistettu viesti OMISTAJA FI sms',
    [MessageEventType.ORDER_CONFIRMATION_COM_SMS_OWNER_EN]:
      'Varaus vahvistettu viesti OMISTAJA EN sms',
    [MessageEventType.ORDER_CONFIRMATION_COM_SMS_CARETAKER_FI]:
      'Varaus vahvistettu viesti HUOLTAJA FI sms',
    [MessageEventType.ORDER_CONFIRMATION_COM_SMS_CARETAKER_EN]:
      'Varaus vahvistettu viesti HUOLTAJA EN sms',
    [MessageEventType.ORDER_BILLS_SEND]: 'Varauksen lasku(t) lähetys',
    [MessageEventType.ORDER_CREATION_TRAVELAGENCY_SEND]:
      'Matkanjärjestäjä varausluonti vahvistus',
  },
};
